export default {
    adjustments: {
        title: 'Anpassungen',
        reset: 'Zusücksetzen',
        light: {
            title: 'Licht',
            brightness: 'Helligkeit',
            contrast: 'Kontrast',
            shadows: 'Schatten',
        },
        color: {
            title: 'Farbe',
            saturation: 'Sättigung',
            temperature: 'Temperatur',
            blacks: 'Schwarze',
            whites: 'Weiße',
        },
        detail: {
            title: 'Detail',
            clarity: 'Klarheit',
            sharpness: 'Schärfe',
            blur: 'Unschärfe',
        },
    },
};
